import { apiGet } from "../../utils/api";
import React, { useEffect, useState } from "react";
import MembersListComponent from "./MembersListComponent";

const Members = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    async function exibir() {
      const payload = apiGet("/members");
      setMembers((await payload).data.data);
    }
    exibir();
  }, []);

  const onChangeHandler = async (e) => {
    const payload = apiGet("/members/pesquisar?termo=" + e.target.value);
    setMembers((await payload).data.data);
  };

  return (
    <div>
      <section id="producoes" style={{ paddingTop: "100px" }}>
        <div className="row text-center justify-content-center">
          <h2 className="text-black mb-4">Participantes</h2>
        </div>

        <div className="row mx-5">
          <div className="col-md-4">
            <div className="search">
              <input
                type="text"
                onChange={(e) => onChangeHandler(e)}
                placeholder="Pesquise por nome..."
              />
            </div>
          </div>
        </div>
        <br />
        <MembersListComponent members={members} />
      </section>
    </div>
  );
};

export default Members;
